import { Label, LabelType, Reason } from 'generated/graphql';

export const isLabelTypeReason = (label: Label): label is Reason => {
  return label.type === LabelType.Reason;
};
